import { medtechApiClient } from '../services/axios';
import { CCWorkflowLink } from '../types/ccWorkflow';
import { Page, PageRequest } from '../utils/pagination';

type CCWorkflowsPageRequest = PageRequest & { includeNotLinked?: boolean };

export const CCWorkflowsApi = {
  fetchCCWorkflowsPage: (
    companyId: number,
    itemId: number,
    { offset, limit, includeNotLinked = false }: CCWorkflowsPageRequest,
  ): Promise<Page<CCWorkflowLink>> =>
    medtechApiClient
      .get<Page<CCWorkflowLink>>(`/v3/${companyId}/change-templates-links/${itemId}`, {
        params: { include_not_linked: includeNotLinked, offset, limit },
      })
      .then(({ data }) => ({ total: data?.total ?? 0, items: data?.items ?? [] })),
  putCCWorkflowLink: async (companyId: number, itemId: number, type: string, matrixIds: string[]) => {
    return medtechApiClient.put(`/v3/${companyId}/change-templates-links/${itemId}`, {
      type,
      matrix_ids: matrixIds,
    });
  },
};
